import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import AssignmentsDetailContainer from './containers/AssignmentsDetail/AssignmentsDetailContainer';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants';
import { ASSIGNMENTS_DETAIL_URL } from 'src/constants/constants.js';
import Layout from 'src/ui/layout';
import { connect } from 'react-redux';

class AssignmentsRoot extends Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.ASSIGNMENTS);
  }
  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.ASSIGNMENTS);
  }
  render() {
    return (
      <Layout headerName={'Mobility Management'}>
        <Switch>
          <Route path={ASSIGNMENTS_DETAIL_URL} render={props => <AssignmentsDetailContainer {...props} />} />
        </Switch>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    location: state.router.location.pathname,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsRoot);
